var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"round-kebab-button",class:_vm.base_class,attrs:{"type":"button"}},[_c('kebab-icon',{staticClass:"round-kebab-button__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }